/**
 * @fileoverview GET handler for the "/:app_group_id/canvas_brief/:canvas_id/download" endpoint.
 * Returns the brief's raw bytes (not JSON), so this uses fetchBlob instead of the standard
 * reactQueryFetcherAdapter and is deliberately not registered in dashboardApiEndpoints (matching
 * getCampaignBriefBlob).
 */
import { fetchBlob } from "@lib/fetch";

import type { GetCanvasBriefBlobProps } from "./types";

/**
 * Streams the persisted brief's bytes from the private bucket. Errors reject the returned promise
 * for the caller to toast on — the global error modal is suppressed so a failed download doesn't
 * double-surface.
 */
export const getCanvasBriefBlob = ({ appGroupId, canvasId }: GetCanvasBriefBlobProps): Promise<Blob> =>
  fetchBlob(
    `/${appGroupId}/canvas_brief/${canvasId}/download`,
    "GET",
    {},
    {},
    // Passing settings replaces fetchBlob's default wholesale, so restate all three keys.
    { setContentType: false, fetchBlobType: true, propagateFetchRequestError: false }
  );
